<template>
  <div class="middle-page">
    <div class="voloro-title text-center middle-page__title mt-80">
      Seamless asset management
    </div>
    <div class="middle-page__card-wrapper layout-p d-flex flex-wrap mt-md-4">
      <b-card
        v-for="card in imageList"
        :key="card.src"
        class="middle-page__card text-center py-lg-3 px-lg-2 mb-3 mr-lg-3"
      >
        <div class="middle-page__card-image">
          <b-img
            class="w-100"
            :src="card.src"
            img-alt="image"
          />
        </div>
        <b-card-text class="middle-page__card-text mt-lg-4 font-20">
          {{ card.text }}
        </b-card-text>
      </b-card>
    </div>

    <div class="middle-page__explanation-wrap layout-p mt-80 pt-0 pr-xl-3">
      <div class="middle-page__explanation">
        <div class="voloro-title">
          Flexibility and liquidity,
          <br>
          as never seen before
        </div>
        <div class="middle-page__explanation-text font-weight-lighter font-20">
          Capture greater value by investing in liquid assets.
          Automatic OTC trading and alternative trading systems
          provide access to a broader range of traders meaning
          that you will be able to exit your positions easily.
        </div>
      </div>

      <div class="middle-page__explanation-img">
        <b-img
          :src="computer"
          img-alt="image"
          class="w-100"
        />
      </div>

      <btn-group
        blueviolet
        class="middle-page__btn-group"
      />
    </div>
  </div>
</template>

<script>
  import calc from '~/assets/img/calc.svg'
  import hand from '~/assets/img/hand.svg'
  import hands from '~/assets/img/hands.svg'
  import computer from '~/assets/img/computer.svg'

  import BtnGroup from '../BtnGroup';

  export default {
    name: 'MiddlePage',
    components: {
      BtnGroup
    },
    data() {
      return {
        computer,
        imageList: [
          {
            src: calc,
            text: 'Access your account balances, holdings and transactions',
          },
          {
            src: hand,
            text: 'Participate in governance events',
          },
          {
            src: hands,
            text: 'Receive dividends for your investments',
          },
        ],
      }
    },
  }
</script>

<style lang="scss" src="./MiddlePage.scss" />
